import React, { useMemo } from 'react';
import DialogConfirm from '../../../../../../components/dialog/dialog-confirm';
import { TDialogWrapperComponent } from '../../../../../../components/dialog/index.types';
import { transactions as types } from 'types';
import { EWithdrawStatusSet } from '../../../../../../types/entities/transactions';
import { Body1 } from 'components/typography';
import useSetTransStatus from '../../hooks/use-set-transaction-status';
import mapTransTypesToUrlNames from 'data-mappers/map-transaction-types-to-url-names';
import getInfoCompByTransType from '../../components/info-by-trans-type/get-info-by-trans-type';

const DialogApprove: React.FC<
    { curData: types.TTransactions } & TDialogWrapperComponent
> = ({ asyncStatesHandlers, setIsDialogOpen, isDialogOpen, curData }) => {
    const [setTrans] = useSetTransStatus(asyncStatesHandlers);

    const InfoComp = useMemo(() => getInfoCompByTransType(curData), [curData]);

    return (
        <DialogConfirm
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Approve'}
            onOk={async () => {
                await setTrans({
                    params: {
                        status: EWithdrawStatusSet.COMPLETED,
                        transactionId: curData.id,
                        type: mapTransTypesToUrlNames(curData.type),
                    },
                });
            }}
        >
            <Body1>
                You want to approve?
                <InfoComp curData={curData} />
            </Body1>
        </DialogConfirm>
    );
};

export default DialogApprove;
